import React from "react";
import "./UploadDesignSection.css"; // Archivo CSS personalizado

const UploadDesignSection = () => {
  return (
    <section id="sube-tu-diseño" className="py-5 upload-design-section">
      <div className="upload-design-container">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            {/* Información */}
            <div className="col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
              <h2 className="upload-design-danger fw-bold">Sube tu diseño</h2>
              <h3 className="fw-bold">¡Hagamos realidad tu idea!</h3>
              <p>
                Con impresión 3D personalizada y materiales de alta calidad.
                Cuéntanos tu idea o sube un archivo para comenzar.
              </p>
            </div>
            {/* Formulario */}
            <div className="col-lg-6">
              <div className="card shadow">
                <div className="card-body">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="nombre" className="form-label">
                        Nombre
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="nombre"
                        placeholder="Tu nombre"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Correo electrónico
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Tu correo"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="link" className="form-label">
                        Link de tu diseño (WeTransfer o similar)
                      </label>
                      <input
                        type="url"
                        className="form-control"
                        id="link"
                        placeholder="https://ejemplo.com"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="material" className="form-label">
                        Elige el material
                      </label>
                      <select className="form-select" id="material" required>
                        <option value="" disabled selected>
                          Selecciona un material
                        </option>
                        <option value="PLA">PLA</option>
                        <option value="ABS">ABS</option>
                        <option value="PETG">PETG</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="descripcion" className="form-label">
                        Cuéntanos más sobre tu proyecto
                      </label>
                      <textarea
                        className="form-control"
                        id="descripcion"
                        rows="4"
                        placeholder="Describe tu idea..."
                        required
                      ></textarea>
                    </div>
                    <div className="d-grid">
                      <button type="submit" className="btn upload-design-btn">
                        Enviar
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UploadDesignSection;
